module.exports = __webpack_public_path__ + "img/wing-right-new.e8a1162d.svg";